
import {AfterViewInit, Component, ElementRef, OnDestroy, OnInit} from '@angular/core';
import { NgbNav } from '@ng-bootstrap/ng-bootstrap';
import { ScreeningDraft } from 'src/app/models/screeningDraft';
import { ScreeningDraftService } from '../services/screening-draft.service';


@Component({
  selector: 'app-screening',
  templateUrl: './screening.component.html',
  styleUrls: ['./screening.component.less'],
})
export class ScreeningComponent implements OnInit, AfterViewInit, OnDestroy {
  directOrderDemographics: ScreeningDraft;
  def: NgbNav
  activeId : number;

  constructor(
    public screeningDrafts: ScreeningDraftService) {

    if(!this.screeningDrafts.directOrderDemographics)  {
      this.screeningDrafts.directOrderDemographics = new ScreeningDraft();
    }else{
      if(this.screeningDrafts.directOrderDemographics.lastCompletedPhase){
        this.activeId = this.screeningDrafts.directOrderDemographics.phaseOverride ? (this.screeningDrafts.directOrderDemographics.phaseOverride + 1) : (this.screeningDrafts.directOrderDemographics.lastCompletedPhase +1);
      }else this.activeId = 1;
    }
  }


  phaseChange(evt: any){
    if(this.activeId == 2 && !this.screeningDrafts.directOrderDemographics.hasVerificationsInPackage) {
      this.activeId = evt + 2;
    } else {
      this.activeId = evt +1;
    }
  }

  navActive(id : number) : boolean {
    return id >= this.screeningDrafts.directOrderDemographics.lastCompletedPhase + 1;
  }

  public ngOnInit(): void {  }

  public ngAfterViewInit(): void { }

  public ngOnDestroy() {
    this.screeningDrafts.directOrderDemographics = undefined;
   }

}
